import {
  getPageInfo,
  getIndividualPageData,
  fetchAPIRequestData
} from '../../../api/global';

import {default as ArticleTemplate} from '../../../components/04_templates/Article/Article';
// import Spinner from '../../../components/01_atoms/Spinner';
import {
  entitiesArrayDrupalSidenav,
} from "../../../utils/transforms";

const blogQuery = {
  'fields[articles]': 'id,internalId,path,title,alias,image',
  'include': 'image,image.imageFile',
  'fields[images]': 'imageFile',
  'fields[files]': 'uri',
  'sort': '-created',
  'filter[isPublished][value]': 1,
  'page[limit]': 4,
  'page[offset]': 0,
};

export async function innerRequests(singleNodeApiRequest, blogQueryNew) {
  singleNodeApiRequest = singleNodeApiRequest || false;
  blogQueryNew = blogQueryNew || blogQuery;

  if (singleNodeApiRequest) {
    return Promise.all([
      fetchAPIRequestData(`/api/rest/view/article-topics`, {}, {type: 'tld'}),
      fetchAPIRequestData(`/articles`, blogQueryNew, {type: 'api'}),
      getIndividualPageData(singleNodeApiRequest),
    ]);
  }
  else {
    return Promise.all([
      fetchAPIRequestData(`/api/rest/view/article-topics`, {}, {type: 'tld'}),
      fetchAPIRequestData(`/articles`, blogQueryNew, {type: 'api'}),
    ]);
  }
}

export async function getStaticProps(context) {
  const {params} = context;
  let initialProps = {
    statusCode: 200,
  };
  let data = null, termsMenu = null, recentNodes = null;

  try {
    [data, termsMenu, recentNodes] = await Promise.all([
      getPageInfo(`/blog/${params.category}/${params.blog.join('/')}`),
      fetchAPIRequestData(`/api/rest/view/article-topics`, {}, {type: 'tld'}),
      fetchAPIRequestData(`/articles`, {
        'fields[articles]': 'id,internalId,path,title,alias,image',
        'include': 'image,image.imageFile',
        'fields[images]': 'imageFile',
        'fields[files]': 'uri',
        'sort': '-created',
        'filter[isPublished][value]': 1,
        'page[limit]': 4,
        'page[offset]': 0,
      }, {type: 'api'}),
    ]);

    // Check for any redirects:
    const regex1 = new RegExp('eatonrealty\.com|\.lndo\.site', 'ig');
    if (data?.page?.redirect && !regex1.test(data.page.redirect?.[0]?.to) && data?.page?.redirect?.length > 0) {
      // For setting GMUSER local storage later during rendering. Otherwise,
      // because of redirect it gets lost and we do not know if the Agent page was loaded from a redirect.
      let dest = data.page?.redirect[0]?.to;
      return {
        redirect: {
          destination: dest,
          statusCode: parseInt(data.page?.redirect[0]?.status),
        },
      }
    }

    if (data && data.page && data.page.entity) {
      let node_data = null;
      node_data = await getIndividualPageData(data.page.jsonapi.individual);
      if (node_data) {
        initialProps = {...initialProps, ...node_data};
      }
    }

    if (!data) {
      return {
        notFound: true,
      }
    }
  }
  catch (e) {
    console.warn('BLOG Internal retrieval error:', e);
    // Pass status code as internal properly. It is being checked inside of
    // render() method of _app.js.
    initialProps.statusCode = 500;

    // In case of Server Side Rendering, we want the server to throw the
    // correct error code.
    // if (res) {
    //   res.statusCode = 500;
    // }
  }
  return {
    props: {
      ...initialProps,
      termsMenu: (termsMenu?.page_data || []),
      recentNodes: (recentNodes?.page_data || [])
    }, // will be passed to the page component as props
    revalidate: 900,
    // notFound: true, // https://github.com/vercel/next.js/discussions/11862,
    // https://stackoverflow.com/questions/67946219/throw-new-errorfailed-to-load-static-props-when-setting-fallback-true-i/67946220#67946220
  }
}

export async function getStaticPaths() {
  const paths = [];
  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return {paths, fallback: true}
}

function BlogPage(props) {
  const node = props.page?.entity || null;
  const meta = props.metatags?.tags || [];
  let node_data = null;

  if (node && props.page_data) {
    node_data = props.page_data;
  }
  if (props.termsMenu) {
    var terms = entitiesArrayDrupalSidenav(props.termsMenu);
  }

  if ((node_data && node.bundle == 'article')) {
    return (
        <ArticleTemplate node={node_data} metatags={meta} terms_menu={terms || []}
                         recent={props.recentNodes || []} blogtitle={true}/>
    );
  }

  return null;
}

export default BlogPage;
